import React from 'react'
import '../App.css'
import logo from '../assets/new logo godrej appliance.png'

const Faqpage = () => {
    return (
        <div>
            <div>
            <img src={logo} alt='logo' width={200} style={{ alignItems: 'left', justifyContent: 'left'}} />
            </div>
            <div>
                <h3>Dear User, kindly adhere to the following steps based on your specific issue:</h3>
            </div>
            <table style={tableStyle}> 
                <thead style={thStyle}>
                    <tr>
                        <th>Problem</th>
                        <th>Reply(Solution)</th>
                    </tr>

                </thead>
                <tbody>
                    <tr>
                        <td style={tdStyle}>Scenario: App UI stuck at
                            verifying credentials after Wi-Fi
                            credentials are provided</td>
                        <td style={tdStyle} className='columnData'>Dear user,
                            Sorry for the inconvenience caused.
                            This problem usually happens when the internet speed is very
                            slow. It's best to have a Wi-Fi connection with a speed of more
                            than 2 Mbps.</td>

                    </tr>
                    <tr>
                        <td style={tdStyle}>Error: Device not found, please
                            reset device.
                        </td>
                        <td style={tdStyle}>Dear User,
                            Sorry for the inconvenience caused.
                            To add your IoT AC to Godrej Smart Life App, follow these
                            steps:
                            <ol style={liStyle}>
                                <li>Make sure the AC power is ON and turn on the AC with
                                    the remote</li>
                                <li>Set the AC to "Cool" mode and the temperature to 31°C
                                    using the remote</li>
                                <li>Press the Wi-Fi button on the remote for 3 seconds.</li>
                                <li>You will hear a beep, and the AC display will blink 3 times</li>
                                <li>If AC display doesn’t blink, go to step #11</li>
                                <li>Press the Wi-Fi button on AC Remote again to turn OFF
                                    configuration mode (Wi-Fi symbol on AC remote display
                                    goes away).
                                </li>
                                <li>Turn OFF the AC power from the switch.
                                </li>
                                <li>Wait for 5-10 seconds.</li>
                                <li>Turn ON the AC power from the switch.</li>
                                <li>Open Godrej Smart Life App and follow the
                                    instructions to add your AC.</li>
                                <li> If still you are not able to add AC, please raise complaint
                                    by calling on 080-6743-6743 or Say Hi on WhatsApp
                                    number 9321665511</li>

                            </ol>
                        </td>
                    </tr>

                </tbody>
            </table>

        </div>
    )
}
const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
  };
  
  const thStyle = {
    // backgroundColor: '#f2f2f2',
    backgroundColor: '#990066',
    padding: '8px',
    border: '1px solid #ddd',
  };
  
  const tdStyle = {
    margin:'5px',
    padding: '8px',
    alignContent: "flex-start"
  };
  
const liStyle = {
  padding: '5px',
  marginLeft: '10px', // Adds space to the left of each <li>
};


  const columnData={
    display:'flex',
    alignItems: 'flex-start',
  }
  

export default Faqpage
